import { render } from "./RemarksMsg.vue?vue&type=template&id=ce361750&scoped=true&ts=true"
import script from "./RemarksMsg.vue?vue&type=script&lang=ts"
export * from "./RemarksMsg.vue?vue&type=script&lang=ts"

import "./RemarksMsg.vue?vue&type=style&index=0&id=ce361750&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce361750"]])

export default __exports__